import React from 'react';
export function OpeningHook() {
  return <section className="bg-dark-surface text-white py-20 px-4 md:px-8" data-id="element-92">
      <div className="max-w-3xl mx-auto" data-id="element-93">
        <h2 className="font-oswald text-3xl md:text-5xl font-bold mb-8 text-center text-brand-orange uppercase" data-id="element-94">
          Admitilo...
        </h2>
        <div className="font-inter text-lg md:text-xl text-gray-300 space-y-6 leading-relaxed" data-id="element-95">
          <p data-id="element-96">
            Ese pantalón que te cerraba perfecto hace un año, hoy te pide
            clemencia. Te mirás al espejo antes de una reunión o un BBQ y ya no
            te reconocés. No es que seas "gordo", es que estás inflamado,
            cansado y con ese "globo" abdominal que no baja con nada.
          </p>
          <p data-id="element-97">
            Lo intentaste todo. Saliste a correr y te dolieron las rodillas.
            Comiste ensalada tres días y terminaste devorando una pizza entera a
            las 11 de la noche por el hambre voraz.
          </p>
          <p className="text-white font-semibold text-xl md:text-2xl border-l-4 border-brand-orange pl-6 my-8" data-id="element-98">
            El problema no es tu fuerza de voluntad, es que tu metabolismo en
            Estados Unidos está bajo ataque constante.
          </p>
        </div>
      </div>
    </section>;
}